import "../../utils/messages";
import { PC_MESSAGES, STATS_NOT_RETRIEVED, USER_MESSAGES, POLICIES_NOT_RETRIEVED, ERROR, POLICY_NOT_RETRIEVED } from "../../utils/messages";
import qs from 'querystring';
import moment from "moment";

export function assignPcRequests(api) {
    const PCS_CONNECTED_ERROR_INTERVAL_MS = 60 * 1000;
    let lastPCsConnectedErrorAt = 0;

    /****************************************PC*********************************************************/
    //export const pcAPI = {

    // Funzione per convertire una stringa in UTF-8
    api.toUtf8 = function (str) {
        return unescape(encodeURIComponent(str));
    }

    api.controlConnectHost = async function (control, remoteId) {
        const data = {
            id_remote: control.idRemote.value,
            password_remote: control.passwordRemote,
            gateway_id: '1',
            target_host_id: remoteId,
            version_remote: control.version_remote,
            country: control.country,
            language: control.language,
            ipaddress_lan: control.ipaddress_lan,
            ipaddress_public: control.ipaddress_public,
            os_version_number: control.os_version_number,
            os_version_full: control.os_version_full,
            computer_name: control.computer_name,
            computer_descr: control.descr,
            organization_name: control.organization_name,
            device: control.device,
            device_guid: control.device_guid,
            remote_guid: control.remote_guid,
            master_account_id: control.operatorid,
            username: control.username,
            id_user: control.id_user,
        };

        try {
            const response = await api.post('/computers/controlconnecthost', data, this.buildConfig());
            return response;
        } catch (error) {
            this.logger.error('Failed to connect to host', error);
            this.createToastFunction(this.translateFunction(USER_MESSAGES.NOT_CONNECTED), "alert");
            return error.response;
        }
    }

    api.controlDisconnectHost = async function (peer, hostConnectedID) {
        const data = {
            id_remote: peer.idRemote.value,
            target_host_id: peer.searchInHosts(hostConnectedID).peerId,
            session_id: peer.searchInHosts(hostConnectedID).idsession,
            effective_time: peer.searchInHosts(hostConnectedID).lastSessionTime.inSeconds.toString(),
            guid_remote: peer.remote_guid,
        };

        try {
            const response = await api.post('/api/controldisconnecthost', JSON.stringify(data));
            return response;
        } catch (error) {
            console.writeError('Failed to disconnect from host', error);
            return error.response;
        }
    }

    /* api.getPCList=async function() {
        var response=await api.get("/computers?gLite=true", this.buildConfig())
            .then(res => res.data.computers.map(pc => { pc.connected=false; pc.connected_remote=false; return pc }))
            .catch(e => {
                console.log(PC_MESSAGES.LIST_NOT_RETRIEVED);
                console.writeError(e);
                this.createToastFunction(this.translateFunction(PC_MESSAGES.LIST_NOT_RETRIEVED), "alert");
                return [];
            });

        return response;
    } */
    api.setFavorite = async function (idPC, enabled) {
        var body = {
            "id": idPC,
            "enabled": enabled ? 1 : 0
        };
        var response = await api.put("/computers/favorites", body, this.buildConfig())
            .then(res => {
                if (enabled) {
                    this.createToastFunction(this.translateFunction(PC_MESSAGES.ADD_TO_FAVORITES), "SUCCESS")
                } else {
                    this.createToastFunction(this.translateFunction(PC_MESSAGES.REMOVE_FROM_FAVORITES), "SUCCESS")
                }

                return res;
            })
            .catch(e => {
                this.checkError(e, ERROR);
                return [];
            });

        return response;
    }

    api.getDevices = async function (filters) {
        var responseComplete = {};
        await api.get("/enterprise/computers?gLite=true&" + qs.stringify(filters), this.buildConfig())
            .then((res) => {
                responseComplete = {
                    computers: res.data.computers.map(_addPropsToPC), has_more: res.data.has_more
                };
            })
            .catch(e => {
                this.checkError(e, PC_MESSAGES.LIST_NOT_RETRIEVED);
                responseComplete = null;
            });
        return responseComplete;
    }

    api.getPCListUltraLite = async function () {
        var responseComplete = {};
        await api.get("/enterprise/computers/list/ultralite", this.buildConfig())
            .then((res) => {
                //TODO : Aggiunto distinct per piccolo errore. Da togliere
                responseComplete = res.data.computers/*.distinctBy("id")*/.map(_addPropsToPC);
            })
            .catch(e => {
                this.checkError(e, PC_MESSAGES.LIST_NOT_RETRIEVED);
                responseComplete = null;
            });
        return responseComplete;
    }

    api.getPCPoliciesList = async function (idPC) {
        var response = await api.get("/enterprise/policies?pc=" + idPC, this.buildConfig())
            .catch(e => {
                this.checkError(e, POLICIES_NOT_RETRIEVED);
                return [];
            });

        return response.data;
    }

    api.getJobPoliciesList = async function (idPC) {
        var response = await api.get("/enterprise/policies/jobs/" + idPC, this.buildConfig())
            .catch(e => {
                this.checkError(e, POLICY_NOT_RETRIEVED);
                return [];
            });

        return response.data;
    }
    api.setDevicePoliciesList = async function (idPC, policiesList) {
        var body = {
            "id_computer": idPC,
            "ids_policies": policiesList
        };
        var response = await api.put("/enterprise/policies/computers", body, this.buildConfig())
            .catch(e => {
                this.checkError(e, POLICIES_NOT_RETRIEVED);
                return [];
            });

        return response;
    }
    api.refreshDevicePolicies = async function (idPC) {
        var body = {
            "pc_ids": [idPC]
        };
        var response = await api.put("/enterprise/refresh/policies", body, this.buildConfig(process.env.VUE_APP_BASE_URL_ENT))
            .catch(e => {
                this.checkError(e, POLICIES_NOT_RETRIEVED);
                return [];
            });

        return response;
    }
    api.getPCRemoteConnected = async function (map_idPC_idRemote) {

        var body = {
            id_list: Object.values(map_idPC_idRemote).join("|")
        };
        var map_idRemote_connected = await api.put("/computers/isonline", body, this.buildConfig())
            .then(res => res.data)
            .catch(e => {
                this.checkError(e, PC_MESSAGES.LIST_NOT_RETRIEVED);
                var notConnectedMap = {};
                for (var [_, idRemote] of Object.entries(map_idPC_idRemote)) {
                    notConnectedMap[idRemote] = false
                }

                return notConnectedMap;
            });

        //map_idRemote_connected = {id_remote: true/false ...}
        //map_idPC_connected = {idPC: true/false ...}
        var map_idPC_connected = {};
        var idRemote
        for (var idPC in map_idPC_idRemote) {
            idRemote = map_idPC_idRemote[idPC];
            map_idPC_connected[idPC] = map_idRemote_connected[idRemote];
        }
        //Al momento restituisco solo ma mappa idPC.connected.
        // In futuro si può pensare di restituire (anche) la mappa idRemote
        return map_idPC_connected;
    }

    api.getPCsConnected = async function (pcIDs) {
        var body = { "pc_ids": pcIDs };
        var connectedMap = await api.put("/enterprise/connected", body, this.buildConfig(process.env.VUE_APP_BASE_URL_ENT))
            .then(res => {
                res = res.data.online_array;
                var obj = {};
                var idPC;

                if (res.length == 0) {
                    pcIDs.forEach(id => {
                        obj[id] = false;
                    });
                    return obj;
                }

                res.forEach(x => {
                    idPC = Object.keys(x)[0]
                    obj[idPC] = x[idPC];
                });
                return obj;
            })
            .catch(e => {
                const now = Date.now();
                if (now - lastPCsConnectedErrorAt >= PCS_CONNECTED_ERROR_INTERVAL_MS) {
                    lastPCsConnectedErrorAt = now;
                    this.checkError(e, PC_MESSAGES.LIST_NOT_RETRIEVED);
                }
                var obj = {};
                pcIDs.forEach(id => {
                    obj[id] = false;
                });
                return obj;

            });

        return connectedMap;
    }

    api.removeFromLicense = async function (idPC) {
        var response = await api.put("/enterprise/license/disconnect", { "id": idPC }, this.buildConfig(process.env.VUE_APP_BASE_URL_ENT))
            .then(res => res.data)
            .catch(e => {
                this.checkError(e, PC_MESSAGES.ERROR);
                return false;
            });

        return response;
    }

    api.addToLicense = async function (idPC) {
        var response = await api.put("/enterprise/license/restore?id", { "id": idPC }, this.buildConfig())
            .then(res => res.statusText)
            .catch(e => {
                this.checkError(e, PC_MESSAGES.ERROR);
                return false;
            });

        return response;
    }

    /** Rimuove un computer da un modulo, chiamato da charms license.js
     * Author TG
     * Date 25/03/2025
     * @param {*} idPC 
     * @param {*} idf 
     * @returns response completa
     */
    api.removeComputerFromModule = async function (idc, idf) {
        var response = await api.put("/enterprise/licenses/features/disable", { "idc": idc, "idf": idf }, this.buildConfig())
            .then(res => res.statusText)
            .catch(e => {
                this.checkError(e, PC_MESSAGES.REMOVE_FROM_MODULE_ERR);
                return false;
            });

        return response;
    }
    /** Associare un computer ad un modulo. chiamato da backup.js
     * Author TG
     * Date 28/03/2025
     * @param {*} idPC 
     * @param {*} idf 
     * @returns response completa
     */
    api.associateComputerToModule = async function (idc, idf) {
        var response = await api.put("/enterprise/licenses/features/enable", { "idc": idc, "idf": idf }, this.buildConfig())
            .then(res => 200 <= res.status && res.status < 300)
            .catch(e => {
                this.checkError(e, PC_MESSAGES.ADD_TO_MODULE_ERR);
                return false;
            });

        return response;
    }

    /*     api.getPcListByGroupID=async function(idGroup) {
            var response=await api.get("/enterprise/computers/list/lite?idg="+idGroup, this.buildConfig())
                .then(res => res.data.computers)
                .catch(e => {
                    console.log(PC_MESSAGES.LIST_NOT_RETRIEVED);
                    console.writeError(e);
                    this.createToastFunction(this.translateFunction(PC_MESSAGES.LIST_NOT_RETRIEVED), "alert");
                    return [];
                });
            return response;
        } */

    /*     api.getPCListLite=async function() {
            var response=await api.get("/enterprise/computers/list/lite/", this.buildConfig())
                .then(res => res.data.computers)
                .catch(e => {
                    console.log(PC_MESSAGES.LIST_NOT_RETRIEVED);
                    console.writeError(e);
                    this.createToastFunction(this.translateFunction(PC_MESSAGES.LIST_NOT_RETRIEVED), "alert");
                    return [];
                });
    
            return response;
        } */

    api.getOTP = async function (pcId) {
        var response = await api.get("/enterprise/remote/connection/otp?pcId=" + pcId, this.buildConfig())
            .then(res => res.data)
            .catch(e => {
                this.checkError(e);
                return null;
            });

        return response;
    }

    api.getPCListWithSubdirectories = async function (idLicense) { //TODO SERVE?
        var response = await api
            .get('/directories/' + idLicense, this.buildConfig())
            .then(response => {

                return {
                    pcList: response.data.computers,
                    subDirectories: response.data.subDirectories
                };
            })
            .catch(e => {
                this.checkError(e, PC_MESSAGES.LIST_NOT_RETRIEVED);
                return [];
            });

        return response;
    }

    api.getPC = async function (idPC) {
        var response = await api.get('/enterprise/computers/' + idPC + "?wg=true", this.buildConfig())
            .then(res => _addPropsToPC(res.data.computer))
            .catch(e => {
                this.checkError(e, PC_MESSAGES.NOT_RETRIEVED);
                return null;
            });

        return response;
    }

    api.getLatestOneVersion = async function (osArch, useBetaChannel = false) {

        //const osArch = navigator.userAgent.includes('WOW64') || navigator.userAgent.includes('Win64') ? 'x64' : 'x86';
        const osArchForQry = osArch.includes('64') ? 'x64' : 'x86';
        const isBeta = useBetaChannel ? '1' : '0';
        const queryString = `?ver=${osArchForQry}&beta=${isBeta}`;

        try {
            const response = await api.get(`/enterprise/version/current${queryString}`, this.buildConfig());
            return response.data; // JSON like { major, minor, ... }
        } catch (e) {
            console.writeError(PC_MESSAGES.LATEST_VERSION_NOT_RETRIEVED, e);
            this.createToastFunction(this.translateFunction(PC_MESSAGES.LATEST_VERSION_NOT_RETRIEVED), 3000, "alert");
            return null;
        }
    }

    api.setPCPassword = async function (pc) {
        const crypto = require('crypto');
        // Convertire la password in UTF-8
        let custom_password = this.toUtf8(pc.custom_password);
        custom_password = crypto.createHash('sha256').update(custom_password).digest('hex').toUpperCase();

        var data = {
            "id": pc.id_setting,
            "custom_password": custom_password,
            "is_protected": 1
        };

        var response = await api.put('/settings/setpwd', data, this.buildConfig())
            .then(resp => resp)
            .catch(e => {
                this.checkError(e);
                return null;
            });

        return response;
    }


    api.removePCPassword = async function (pc) {

        var data = {
            "id": pc.id_setting,
        };

        var response = await api.put('/settings/removepwd', data, this.buildConfig())
            .then(resp => resp)
            .catch(e => {
                this.checkError(e);
                return null;
            });

        return response;
    }

    api.editPC = async function (pc) {


        var data = {
            "id": pc.id_setting,
            "computer_id": pc.id,
            "id_user": pc.id_user,
            "pc_name": pc.name,
            "description": pc.description,
            "organization": pc.organization_name,
            "setting_attribute": "2",
            "group_attribute": pc.attribute,
            "is_protected": pc.is_protected,
            "pc_status": pc.pc_status,
            "ids_groups": pc.groups
        };

        var body = JSON.stringify(data);



        if (pc.attribute == "3") {

            var response = await api.post(
                '/settings',
                body,
                this.buildConfig()
            ).then(res => {
                if (res.status == 400) return null;
                return true;
            }).catch(e => {
                this.checkError(e, PC_MESSAGES.NOT_MODIFIED);
                return false; //e.data.errors;
            })

        } else {

            var response = await api.put(
                '/settings',
                body,
                this.buildConfig()
            ).then(res => {
                if (res.status == 400) return null;
                return true;
            }).catch(e => {
                this.checkError(e, PC_MESSAGES.NOT_MODIFIED);
                return false //e.data.errors;
            });
        }

        if (response == null)
            this.createToastFunction(this.translateFunction(PC_MESSAGES.NOT_MODIFIED), "alert");

        return response;
    }

    api.getStatsFromPC = async function (idPC) {
        var endDate = moment(new Date()).format("YYYYMMDDhhmmss");

        var response = await api.get('/enterprise/stats/computer?id=' + idPC + '&dt_start=20200101000000&dt_end=' + endDate + '&stepped=true',
            this.buildConfig())
            .then(res => res.data)
            .catch(e => {
                this.checkError(e, STATS_NOT_RETRIEVED);
                return [];
            });

        return response;
    }

    api.getStatsFromLicense = async function (startDate, endDate) {
        var startDate = moment(startDate).format("YYYYMMDDhhmmss");
        var endDate = moment(endDate).format("YYYYMMDDhhmmss");
        var response = await api.get(
            '/enterprise/stats/license?dt_start=' + startDate + '&dt_end=' + endDate + '&stepped=true',
            this.buildConfig())
            .then(res => res.data)
            .catch(e => {
                this.checkError(e, STATS_NOT_RETRIEVED);
                return [];
            });

        return response;
    }

    api.getStatsFromLicenseLight = async function (idgroup) {
        var response = await api.get(
            '/enterprise/stats/mainV2' + (idgroup != null ? '?idg=' + idgroup : ''),
            this.buildConfig())
            .then(res => res.data)
            .catch(e => {
                this.checkError(e, STATS_NOT_RETRIEVED);
                return null;
            });

        return response;
    }
    //Restituisce un array di oggetti di tipo:
    //{
    //  id_group:...
    //  name_group:...
    //  num_computers:...
    //}
}

function _addPropsToPC(pc) {

    pc.connected = false;
    pc.connected_remote = false;
    pc.oneIsInstalled = pc.backup_license_status == 1;
    /*!=undefined&&
        pc.backup_license_status>0&&
        pc.version_backup!=undefined;*/

    switch (pc.backup_license_status) {
        case undefined:
        case 0:
            pc.notConnectedDefaultMessage = "Iperius One Agent not installed";
            pc.healthMessageParts = null;
            pc.healthMessage = "Iperius One Agent not installed";
            pc.healthColor = "fg-gray";
            pc.iconHeight = 20;
            return pc;
        case 1:
            pc.notConnectedDefaultMessage = "Iperius One Agent not started";
            pc.iconHeight = 20;

            break;
        case 2:
            pc.notConnectedDefaultMessage = "Waiting to restart agent";
            pc.healthMessageParts = null;
            pc.healthMessage = "Waiting to restart agent";
            pc.healthColor = "fg-gray";
            pc.iconHeight = 25;

            return pc;
        case 3:
            pc.notConnectedDefaultMessage = "Licence removed from this device";
            pc.healthMessageParts = null;
            pc.healthMessage = "Licence removed from this device";
            pc.healthColor = "fg-gray";
            pc.iconHeight = 25;

            return pc;
    }

    /*if (!pc.oneIsInstalled) {
        pc.notConnectedDefaultMessage="Iperius One Agent not installed";
        pc.healthMessageParts=null;
        pc.healthMessage="Iperius ONE not installed";
        pc.healthColor="fg-gray";
        return pc;
    }*/
    switch (pc.av_alert + pc.disk_alert + pc.os_patches_alert) {
        case 0:
            pc.healthMessageParts = null;
            pc.healthMessage = "Device Health : Good";
            pc.healthColor = "fg-green";
            break;

        default:
            pc.healthMessage = null
            pc.healthMessageParts = ["Device Health :"];
            if (pc.av_alert == 1) {
                pc.healthMessageParts.push("Check antivirus and firewall");
            }

            if (pc.disk_alert == 1) {
                pc.healthMessageParts.push("Check disks status");
            }

            if (pc.os_patches_alert == 1) {
                pc.healthMessageParts.push("Check OS update");
            }

            pc.healthColor = pc.healthMessageParts.length == 3
                ? "fg-red"
                : "fg-orange";
            break;
    }
    return pc
}
